var React = require('react');
var createReactClass = require('create-react-class');
var QuestionTitle = require('../../components/questionTitle.jsx');
var Helmet = require('react-helmet');

var ContactSuccess = createReactClass({
  render: function(){
    return (
		<div className="content">
         	<Helmet title='Thank You For Contacting Us'/>
            <QuestionTitle mainLabel="Your message has been received!" subLabel="We will be in touch shortly." />
        </div>
    )
  }
});

module.exports = ContactSuccess;


// WEBPACK FOOTER //
// ./src/common/routes/contact-success/components/contact-success.jsx